import React, { useEffect, useState } from "react";
import "./header.css";
import logo from "../Assets/Logo Png.png";
import logo1 from "../Assets/phone-png.png";
import logo2 from "../Assets/email-png.png";
import logo3 from "../Assets/facebook-link.png";
import logo4 from "../Assets/twitter-link.png";
import logo5 from "../Assets/linkedin-link.png";
import logo6 from "../Assets/instagram.png";
import { BsThreeDots } from "react-icons/bs";

function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  function dotClick() {
    setIsOpen(!isOpen);
  }
  return (
    <div className={`header ${isSticky ? "sticky" : ""}`}>
      <div className="header-logo">
        <a href="/" target="_top">
          <img
            src={logo}
            alt="Logo"
            // onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          />
        </a>
      </div>
      <div className={`header-content ${isOpen ? "visible" : ""}`}>
        <div className="phone">
          <div>
            <img src={logo1} alt="phone" className="header-icons" />
          </div>
          <div className="phone-content">
            <p>Emergency Line</p>
            <div className="bold">+91 99665 00800</div>
          </div>
        </div>
        <div className="email">
          <div>
            <img src={logo2} alt="email" className="header-icons" />
          </div>
          <div className="email-content">
            <p>Support Email</p>
            <div className="bold">info@shriadithyahospitals.com</div>
          </div>
        </div>
        <div className="img-section">
          <a
            href="https://www.facebook.com/share/15syJiam4F/?mibextid=wwXIfr"
            target="_blank"
          >
            <img src={logo3} alt="" className="header-icons" />
          </a>
          <a href="https://x.com/AdithyaHospital" target="_blank">
            <img src={logo4} alt="" className="header-icons" />
          </a>
          {/* <a
            href="https://www.instagram.com/shri.adithyahospitals/?hl=en"
            target="_blank"
          > */}
          <img src={logo5} alt="" className="header-icons" />
          {/* </a> */}
          <a
            href="https://www.instagram.com/shri.adithyahospitals?igsh=MXRkM2RocGp6a3hncw%3D%3D&utm_source=qr"
            target="_blank"
          >
            <img src={logo6} alt="" className="header-icons" />
          </a>
        </div>
      </div>
      <BsThreeDots className="three-dot" onClick={dotClick} />
    </div>
  );
}

export default Header;
